import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { FacilityType } from "../..";

@Injectable()
export class FacilityTypeService extends BaseDataService<FacilityType> {
  constructor(http: HttpService) {
    super(http, "facilitytype");
  }

  createInstance(options: any): FacilityType {
    return new FacilityType(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
